import React, { forwardRef, useState } from 'react';
import classNames from 'classnames';

import { Input, InputProps } from '../input';
import FileInfoCard from '../../molecules/file-info-card/FileInfoCard';
import Text from '../text/Text';

export type Props = InputProps;

// eslint-disable-next-line react/display-name
export const FileInput = forwardRef<HTMLInputElement, Props>(
  ({ name, onChange, defaultValue, ...props }: Props, ref) => {
    const [file, setFile] = useState(defaultValue);

    const onChangeFile = (e) => {
      if (e.target.files && e.target.files.length > 0) {
        const fileName: string = e.target?.files?.[0].name;
        setFile(fileName);
      }

      onChange && onChange(e);
    };

    const onClick = () => setFile('');

    return (
      <>
        <label className={classNames('pointer', { 'd-none': file })}>
          <Input
            ref={ref}
            name={name}
            type="file"
            onChange={onChangeFile}
            controlling
            {...props}
          />
        </label>

        {file ? (
          <FileInfoCard
            title={file}
            secondaryComponent={
              <div onClick={onClick} className="pointer">
                <Text color="danger">Delete</Text>
              </div>
            }
            withoutBg
          />
        ) : null}
      </>
    );
  },
);
